<main>
    <h1 class="main sticky-top">
        <div class="row">
            <div class="col-sm-12">{{ user.UserPortal.PortalName }}</div>
        </div>
    </h1>

    <section class="content" aria-labelledby="portal-administration-heading">
        <h2 id="portal-administration-heading" class="visually-hidden">Portal Administration</h2>
        <portal-info [(portalInfo)]="portalInfo"></portal-info>
    </section>
</main>
